import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=05a2cdbd&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=05a2cdbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a2cdbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a2cdbd')) {
      api.createRecord('05a2cdbd', component.options)
    } else {
      api.reload('05a2cdbd', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=05a2cdbd&scoped=true&", function () {
      api.rerender('05a2cdbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27y3kBoSJZE1T/JS/comp/PopupDialog.vue"
export default component.exports